import carousel from './carousel';

export default carousel;
